<template>
  <AffiliateLandingPage
    imageExt="png"
    imageName="PerksAtWork"
    routePath="perksatwork"
    company="Perks at Work"
  ></AffiliateLandingPage>
</template>

<script>
import AffiliateLandingPage from '@/components/Affiliate/AffiliateLandingPage.vue'

export default {
  components: {
    AffiliateLandingPage
  },
  name: 'PerksAtWorkLandingPage'
}
</script>

<style></style>
